export default __webpack_public_path__ + "static/bg_home-4a6f4e8ec8548b1319c4237d9f1bd8a2.webp";